const sectorsSidebar = {
  sector: 'Sector',
  selectedSectors: 'Selected sectors',
  allSectors: 'All Sectors',
};

export default sectorsSidebar;
